import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "rounded-2xl border border-slate-200 bg-white p-5 shadow-sm" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-400" }, "Endereço de entrega", -1)
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex items-start gap-3" }
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "flex items-center gap-2" }
const _hoisted_7 = { class: "rounded-full bg-slate-100 px-2 py-0.5 text-xs text-slate-400" }
const _hoisted_8 = { class: "mt-1 truncate text-sm font-semibold text-slate-950" }
const _hoisted_9 = { class: "flex items-center gap-2" }
const _hoisted_10 = ["disabled", "onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "my-5 flex items-center gap-3 text-xs text-slate-400" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "h-px flex-1 bg-slate-200" }),
  /*#__PURE__*/_createElementVNode("span", null, "ou adicionar novo"),
  /*#__PURE__*/_createElementVNode("span", { class: "h-px flex-1 bg-slate-200" })
], -1)
const _hoisted_12 = { class: "flex gap-2" }
const _hoisted_13 = ["value"]
const _hoisted_14 = {
  key: 0,
  class: "mt-3 rounded-xl border border-slate-200 bg-slate-50 p-4"
}
const _hoisted_15 = { class: "mb-3 flex gap-2 text-sm" }
const _hoisted_16 = { class: "block text-slate-950" }
const _hoisted_17 = { class: "text-slate-500" }
const _hoisted_18 = { class: "grid grid-cols-1 gap-3 sm:grid-cols-2" }
const _hoisted_19 = { class: "text-xs font-medium text-slate-600" }
const _hoisted_20 = ["value"]
const _hoisted_21 = { class: "text-xs font-medium text-slate-600" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", { class: "text-slate-400" }, "(opcional)", -1)
const _hoisted_23 = ["value"]
const _hoisted_24 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", {
      class: _normalizeClass(["space-y-3 pr-1", _ctx.normalizedAddresses.length > 3 ? 'max-h-[244px] overflow-y-auto' : ''])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.normalizedAddresses, (item) => {
        return (_openBlock(), _createElementBlock("button", {
          key: `${item.type}-${item.id}`,
          type: "button",
          class: _normalizeClass(["w-full rounded-xl border p-4 text-left transition", _ctx.isSelected(item) ? 'border-slate-950 bg-slate-50' : 'border-slate-200 hover:border-slate-400']),
          onClick: ($event: any) => (_ctx.$emit('select-address', item))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", {
              class: _normalizeClass(["mt-1 h-4 w-4 rounded-full border-2", _ctx.isSelected(item) ? 'border-slate-950 bg-slate-950' : 'border-slate-300'])
            }, null, 2),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(item.zip_code), 1)
              ]),
              _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.formatAddress(item)), 1)
            ]),
            _createElementVNode("div", _hoisted_9, [
              (item.type == 'entrega')
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    type: "button",
                    class: "rounded-lg p-1 text-slate-300 hover:bg-red-50 hover:text-red-500",
                    disabled: _ctx.deletingAddressId == item.id,
                    onClick: _withModifiers(($event: any) => (_ctx.$emit('delete-address', item)), ["stop"])
                  }, [
                    _createVNode(_component_Icon, {
                      icon: _ctx.deletingAddressId == item.id ? 'svg-spinners:180-ring' : 'mdi:trash-can-outline'
                    }, null, 8, ["icon"])
                  ], 8, _hoisted_10))
                : _createCommentVNode("", true),
              (_ctx.isSelected(item))
                ? (_openBlock(), _createBlock(_component_Icon, {
                    key: 1,
                    icon: "mdi:check-circle-outline",
                    class: "text-slate-950"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ], 10, _hoisted_3))
      }), 128))
    ], 2),
    _hoisted_11,
    _createElementVNode("div", _hoisted_12, [
      _withDirectives(_createElementVNode("input", {
        value: _ctx.cep,
        "data-maska": "#####-###",
        placeholder: "00000-000",
        class: "h-11 flex-1 rounded-xl border border-slate-200 px-4 text-sm outline-none focus:border-slate-950",
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:cep', ($event.target as HTMLInputElement).value)))
      }, null, 40, _hoisted_13), [
        [_directive_maska]
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "h-11 rounded-xl bg-slate-950 px-5 text-sm font-bold text-white",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('search-cep')))
      }, " Buscar ")
    ]),
    (_ctx.showNewAddressForm)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createVNode(_component_Icon, {
              icon: "solar:map-point-linear",
              class: "mt-0.5 text-slate-400"
            }),
            _createElementVNode("div", null, [
              _createElementVNode("strong", _hoisted_16, _toDisplayString(_ctx.address.street || 'Endereço encontrado'), 1),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.address.neighborhood) + " " + _toDisplayString(_ctx.address.city ? `, ${_ctx.address.city}/${_ctx.address.state}` : ''), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("label", _hoisted_19, [
              _createTextVNode(" Número "),
              _createElementVNode("input", {
                value: _ctx.number,
                placeholder: "Ex: 142",
                class: "mt-1 h-10 w-full rounded-lg border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('update:number', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_20)
            ]),
            _createElementVNode("label", _hoisted_21, [
              _createTextVNode(" Referência "),
              _hoisted_22,
              _createElementVNode("input", {
                value: _ctx.complement,
                placeholder: "Apto, bloco...",
                class: "mt-1 h-10 w-full rounded-lg border border-slate-200 px-3 text-sm outline-none focus:border-slate-950",
                onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('update:complement', ($event.target as HTMLInputElement).value)))
              }, null, 40, _hoisted_23)
            ])
          ]),
          _createElementVNode("button", {
            type: "button",
            class: "mt-3 flex h-11 w-full items-center justify-center gap-2 rounded-xl bg-slate-950 text-sm font-bold text-white disabled:cursor-not-allowed disabled:bg-slate-400",
            disabled: _ctx.savingAddress,
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('use-new-address')))
          }, [
            (_ctx.savingAddress)
              ? (_openBlock(), _createBlock(_component_Icon, {
                  key: 0,
                  icon: "svg-spinners:180-ring"
                }))
              : _createCommentVNode("", true),
            _createTextVNode(" " + _toDisplayString(_ctx.savingAddress ? 'Salvando endereço...' : 'Usar este endereço'), 1)
          ], 8, _hoisted_24)
        ]))
      : _createCommentVNode("", true)
  ]))
}